import { RichTextEditorToolbar } from '@modules/common/components/RichTextEditor/RichTextEditorToolbar';
import { richTextEditorContainerSX } from '@modules/common/components/RichTextEditor/constants';
import { richTextEditorExtensions } from '@modules/common/components/RichTextEditor/richTextEditorExtensions';
import { Box } from '@mui/material';
import { BubbleMenu, EditorOptions, EditorProvider } from '@tiptap/react';
import { useRef } from 'react';

interface RichTextEditorProps extends Partial<EditorOptions> {}

export function RichTextEditor({ onUpdate, content }: RichTextEditorProps) {
  const shouldForceCloseBubbleMenuRef = useRef<boolean | null>(null);

  return (
    <Box
      spellCheck="false"
      aria-expanded="false"
      sx={richTextEditorContainerSX}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <EditorProvider
        extensions={richTextEditorExtensions}
        content={content}
        onUpdate={onUpdate}
        autofocus={true}
      >
        <BubbleMenu
          updateDelay={50}
          // Workaround to control the menu visibility to make it work with the link/typography formatting dropdowns
          shouldShow={(inputs) => {
            if (shouldForceCloseBubbleMenuRef.current !== null) {
              return !shouldForceCloseBubbleMenuRef.current;
            }

            return (
              inputs.editor.isFocused &&
              inputs.editor.isEditable &&
              !!inputs.state.selection &&
              inputs.from !== inputs.to
            );
          }}
        >
          <RichTextEditorToolbar
            forceCloseBubbleMenu={() => {
              shouldForceCloseBubbleMenuRef.current = true;

              setTimeout(() => {
                shouldForceCloseBubbleMenuRef.current = null;
              }, 200);
            }}
          />
        </BubbleMenu>
      </EditorProvider>
    </Box>
  );
}
